const initialState = {
  providerList: [],
  archivedCount: 0,
};

const providerList = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROVIDER_LIST':
      return {
        ...state,
        providerList: action.providerList,
        archivedCount: action.archivedCount != null ? action.archivedCount : state.archivedCount,
      };
    default:
      return state;
  }
};

export default providerList;
